import { render, staticRenderFns } from "./pt.vue?vue&type=template&id=d279cc90&scoped=true&"
import script from "./pt.vue?vue&type=script&lang=js&"
export * from "./pt.vue?vue&type=script&lang=js&"
import style0 from "./pt.vue?vue&type=style&index=0&id=d279cc90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d279cc90",
  null
  
)

export default component.exports